/**
 * Route constants for the guest-facing supplier portal.
 *
 * Kept free of Angular imports on purpose: the root routing module, guest-login, the error
 * handler and the staff RFQ page all need these paths, and importing anything heavier from the
 * lazily-loaded portal would drag its chunk into the main bundle.
 */
export const SUPPLIER_PORTAL_PATH = 'supplier-portal';

/** The guest permission string the backend issues to invited suppliers. */
export const SUPPLIER_PORTAL_PERMISSION = 'rfq_view';

export const supplierPortalUrls = {
  home: `/${SUPPLIER_PORTAL_PATH}`,
  quotations: `/${SUPPLIER_PORTAL_PATH}/quotations`,
  quotation: (id: string) => `/${SUPPLIER_PORTAL_PATH}/quotations/${id}`,
  orders: `/${SUPPLIER_PORTAL_PATH}/orders`,
  order: (id: string) => `/${SUPPLIER_PORTAL_PATH}/orders/${id}`,
} as const;
